export default {
  computed: {
    selectedWarehouse() {
      const { items } = this.$store.state.warehouse;
      if (!items || !items.length) return null;
      
      // Support both warehouse object and warehouse_id
      const warehouseId = this.editedItem?.warehouse?.id || this.editedItem?.warehouse_id;
      
      return (
        items.find((warehouse) => warehouse.id === warehouseId) || items[0]
      );
    },
  },
};
